import Resource from './resource/base/Resource';

class ApiClientSingleton {
  constructor() {
    this.facility = new Resource('/public/facilities/');
    this.download = new Resource('/public/download/');
    this.feedback = new Resource('/public/feedback');
  }
}

const ApiClient = new ApiClientSingleton();
export default ApiClient;



// WEBPACK FOOTER //
// ./src/services/api-client/ApiClient.jsx